import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="12" height="12" rx="6" fill="#FF0000"></rect>
        <path
          d="M5.3457 3.97302V3.72977C5.3457 3.32677 5.65102 3 6.02756 3C6.40409 3 6.70941 3.32677 6.70941 3.72977V3.97302"
          stroke="white"
          strokeWidth="0.7"
          strokeMiterlimit="10"
        ></path>
        <path
          d="M3.52734 3.97266H8.52761"
          stroke="white"
          strokeWidth="0.7"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M4.13281 3.97266V8.35127C4.13281 8.7095 4.40419 8.99995 4.73891 8.99995H7.3148C7.64951 8.99995 7.92089 8.7095 7.92089 8.35127V3.97266"
          stroke="white"
          strokeWidth="0.7"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M5.49609 5.27051V7.70307"
          stroke="white"
          strokeWidth="0.7"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M6.55664 5.27051V7.70307"
          stroke="white"
          strokeWidth="0.7"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
      </svg>
    </>
  );
};
